import { ORDER_INQUIRY_IMAGES_MAX } from '@repo/api-contracts';
import { trpc } from '@/shared/api';
import { useImageUploadQueue } from '@/shared/lib';

export const useOrderInquiryImageUploads = () => {
  const presign = trpc.myOrderInquiries.presignImage.useMutation();
  const confirm = trpc.myOrderInquiries.confirmImage.useMutation();
  return useImageUploadQueue({
    max: ORDER_INQUIRY_IMAGES_MAX,
    initial: [],
    presign: (contentType) => presign.mutateAsync({ contentType }),
    confirm: (imageId) => confirm.mutateAsync({ imageId }),
  });
};
